import { render, staticRenderFns } from "./RegisterLogin.vue?vue&type=template&id=5ac715d8"
import script from "./RegisterLogin.vue?vue&type=script&lang=js"
export * from "./RegisterLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac715d8')) {
      api.createRecord('5ac715d8', component.options)
    } else {
      api.reload('5ac715d8', component.options)
    }
    module.hot.accept("./RegisterLogin.vue?vue&type=template&id=5ac715d8", function () {
      api.rerender('5ac715d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/checkout/components/RegisterLogin.vue"
export default component.exports